import styled from 'styled-components'
import {
  textStyleSizeOptions,
  textStyleSizeStyleOptions,
  textStyleWeightOptions,
  textStyleWeightStyleOptions
} from '../../../../fundamentals/text-styles/constants.js'
import colorsOptions from '../../../../fundamentals/colors-styles/constants.js'

export const HeaderContainer = styled.th`
  padding: 0.5rem;
  justify-items: ${({ orientation }) => orientation || 'left'};
  text-align: ${({ orientation }) => orientation || 'left'};

  width: ${({ width }) =>
    !width ? 'auto' : typeof width === 'string' ? width : `${width}px`};
  min-width: ${({ minWidth, width }) => {
    if (minWidth !== undefined)
      return typeof minWidth === 'string' ? minWidth : `${minWidth}px`
    if (!width) return 'auto'
    return typeof width === 'string' ? width : `${width}px`
  }};

  background-color: ${colorsOptions.greys.white};
  height: 32px;

  &:first-child {
    border-top-left-radius: 8px;
  }

  &:last-child {
    border-top-right-radius: 8px;
  }

  &:hover {
    background-color: ${colorsOptions.greys['grey-05']};
  }
  border-bottom: 1px solid ${colorsOptions.greys['grey-30']};

  ${({ disabled }) => disabled && 'pointer-events: none;'}
`

export const HeaderText = styled.span`
  display: flex;
  gap: 0.25rem;
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-600']]};
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-S']]};
  line-height: 15.6px; /* 130% */
  letter-spacing: 0.2px;
  color: ${({ sortDirection, disabled }) =>
    disabled
      ? colorsOptions.greys['grey-40']
      : sortDirection
        ? colorsOptions.docuToolsOrange.orange
        : 'inherit'};
`
